module.exports = __webpack_public_path__ + "img/UY.0c5b518d.svg";